<template>
  <div>
    <div id="main">
      <nav v-bind:class="activeMenu" v-on:click.prevent>
        <div class="row headerTop">
          <div class="col-2 ht100" style="text-align: center; ">
            <div class="row ht100" v-if="currAdmin.location">
              <div class="col-12 ht100">
                <img
                  class="ht100 logosize"
                  :src="'https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2F' + currAdmin.location + '_logo.png?alt=media&token=40e166d5-7119-412f-a481-54bca80ae993'"
                />
              </div>
            </div>

            <div class="row" v-else>
              <div class="col-12" style="font-weight: bold">{{locParams.name || ''}}</div>
            </div>
          </div>

          <div class="col-9 headerTop routerLinkStyle rsize">
            <router-link :to="{name: 'Chat'}" v-on:click.native="activeMenu = 'Chat'" class="Chat">
              Chat
              <b-badge v-if="unreadMsg.chat != 0" variant="danger">{{unreadMsg.chat}}</b-badge>
              <b-badge
                v-if="unreadMsg.sms != 0"
                variant="primary"
                style="margin-left: 5px;"
              >{{unreadMsg.sms}}</b-badge>
            </router-link>

            <div style="display: inline">
              <router-link
                :to="{name: 'Notifications'}"
                v-on:click.native="activeMenu = 'Notifications'"
                class="Notifications"
              >
                Notifications
                <b-badge variant="primary" v-if="newNotifsCount >= 0">{{newNotifsCount}}</b-badge>
              </router-link>
            </div>
            <router-link
              :to="{name: 'TimeControl'}"
              v-on:click.native="activeMenu = 'TimeControl'"
              class="TimeControl"
            >Time control</router-link>

            <!-- <div style="display: inline">
              <router-link
                :to="{name: 'FollowUpPanel'}"
                v-on:click.native="activeMenu = 'FollowUpPanel'"
                class="FollowUpPanel"
              >
                FollowUp
                <b-badge variant="danger" v-if="flpAlertCounter > 0">{{flpAlertCounter}}</b-badge>
              </router-link>
            </div>-->
            <!-- v-if="currAdmin.id == 'zuvyY7h1PTT1YCii5Q5Y' || currAdmin.id == 'A25ezq3nj0PWotHRQ8ZB' || currAdmin.id == 'OsINARa0OtMVeg0CvFPD' || currAdmin.id == '1cSgjGyElchRbyniMVMk'" -->
            <!-- v-if="currAdmin.role <= 3" -->
            <div style="display: inline">
              <router-link
                :to="{name: 'ReminderPanel'}"
                v-on:click.native="activeMenu = 'ReminderPanel'"
                class="ReminderPanel"
              >Reminders</router-link>
            </div>

            <div v-if="currAdmin.role < 3" style="display: inline">
              <router-link
                :to="{name: 'Settings'}"
                v-on:click.native="activeMenu = 'Settings'"
                class="Settings"
              >Access Controls</router-link>
            </div>
          </div>

          <div class="col-1 lineH50">
            <b-dropdown
              id="dropdownProfile"
              variant="info"
              :text="currAdmin.userOptionalName ? currAdmin.userOptionalName[0] : currAdmin.user_google_name ? currAdmin.user_google_name[0] : 'P'"
              class="logoutAvatarClass"
              :right="true"
              :no-caret="true"
            >
              <b-dropdown-item>
                <b-avatar
                  v-if="currAdmin.userOptionalName || currAdmin.user_google_name"
                  variant="info"
                  :text="currAdmin.userOptionalName != '' ? currAdmin.userOptionalName[0] : currAdmin.user_google_name[0]"
                  size="83px"
                ></b-avatar>
                <p
                  class="userNameStyle"
                >{{currAdmin.userOptionalName || currAdmin.user_google_name}}</p>
                <p class="userEmailStyle">{{currAdmin.email}}</p>
                <p>Access level: {{rolePool[currAdmin.role]}}</p>
              </b-dropdown-item>

              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item>
                <b-button
                  class="profBtn"
                  @click="SetMySets()"
                  v-b-modal.modal-mySets
                  variant="outline-info"
                >My Settings</b-button>
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item>
                <b-button class="profBtn" variant="outline-danger" @click="logOut()">Logout</b-button>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </nav>
    </div>

    <!-- MODAL START -->
    <b-modal
      id="modal-mySets"
      @ok="ApplyMySetChanges"
      ok-title="Apply Changes"
      size="lg"
      centered
      title="My settings"
    >
      <b-input-group size="sm" class="mb-3" prepend="First Name:">
        <b-form-input
          :state="profileAdmin.firstName != '' ? true : false"
          v-model="profileAdmin.firstName"
          :placeholder="currAdmin.user_google_name.split(' ')[0]"
        ></b-form-input>
      </b-input-group>

      <b-input-group size="sm" class="mb-3" prepend="Last Name:">
        <b-form-input
          required
          :state="profileAdmin.lastName != '' ? true : false"
          v-model="profileAdmin.lastName"
          :placeholder="currAdmin.user_google_name.split(' ')[1]"
        ></b-form-input>
      </b-input-group>

      <div v-if="currAdmin.role <= 2">
        <div class="row" style="text-align: left;margin-bottom: 10px;">
          <div class="col-6" style="border-right: 1px solid darkblue">
            <b-form-checkbox v-model="profileAdmin.chatRoute">Assign conversations to me</b-form-checkbox>
          </div>

          <div class="col-6">
            <b-form-checkbox v-model="profileAdmin.showNotifications">Receive notifications</b-form-checkbox>
          </div>
        </div>

        <div class="row" style="text-align: left; margin-bottom: 10px;">
          <div class="col-6" style="border-right: 1px solid darkblue; ">
            <b-form-checkbox v-model="profileAdmin.transcriptToEmail">Receive transcript to email</b-form-checkbox>
          </div>

          <div class="col-6">
            <b-form-checkbox v-model="profileAdmin.popupAllowed">Popup window</b-form-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="col-4" style="margin-top:10px; text-align: right;">
            <b-form-checkbox v-model="profileAdmin.noteToEmail">Receive notifications to</b-form-checkbox>
          </div>
          <div class="col-8">
            <b-form-input
              v-model="profileAdmin.notificationsToEmail"
              :disabled="!profileAdmin.noteToEmail"
            ></b-form-input>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- MODAL ENDING -->

    <keep-alive>
      <router-view
        :currAdmin="currAdmin"
        :rooms="rooms"
        :roomStats="roomStats"
        :messages="messages"
        :admins="adminsOnline"
        v-on:blockNote="blockNoteList.push($event)"
        v-on:selectedRoom="selectedRoomId = $event"
        :notifs="allNotifs"
        :notifications="notifications"
        :unsentList="activeFollowUps"
      ></router-view>
    </keep-alive>
  </div>
</template>

<script>
import firebase from "../../firebase";
import "firebase/firestore";
import "firebase/auth";

var track = new Audio(
  "https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/notif_sound%2Fjust-saying.mp3?alt=media&token=cdc25aba-f0aa-421b-b7fe-b1ae87b0123f"
);
var track2 = new Audio(
  "https://firebasestorage.googleapis.com/v0/b/friendlychat-2e004.appspot.com/o/sound_notif%2Fsoft_notification.mp3?alt=media&token=286f6872-55ef-4776-96d1-001be678d72a"
);

var statusTrack = new Audio(
  "https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/notif_sound%2Fmixkit-censorship-beep-1082.wav?alt=media&token=e466a359-71d7-48aa-996e-00ad48987564"
);

export default {
  name: "Home",
  props: {
    currAdmin: Object,
    locParams: Object
  },
  components: {},
  data() {
    return {
      allNotifs: {},
      notifications: [],
      selectedRoomId: "",
      noteBlock: true,
      blockNoteList: [],
      activeMenu: "",
      notifCounter: 0,
      adminsOnline: [],
      rooms: [],
      roomStats: {},
      messages: {},
      activeFollowUps: [],
      profileAdmin: {},
      rolePool: ["Super Admin", "Admin", "Manager", "Appointment coordinator"]
    };
  },
  watch: {
    selectedRoomId: function(val) {
      if (this.valid(val)) {
        this.SetLastCheckTime(val);
      }
    }
  },
  computed: {
    flpAlertCounter() {
      return this.activeFollowUps.filter(el => el.status == "review").length;
    },
    newNotifsCount() {
      let r = 0;
      for (let ky in this.allNotifs) {
        let note = this.allNotifs[ky];
        r =
          note.processed_status != "in_process" &&
          note.processed_status != "processed"
            ? r + 1
            : r;
      }
      return r;
    },
    unreadMsg() {
      let r = 0;
      let rsms = 0;

      this.rooms.forEach(rm => {
        if (this.valid(rm.ssId) && this.messages[rm.ssId] != undefined) {
          if (
            this.messages[rm.ssId].find(
              el => el.route.from == "client" && el.readMsg === false
            )
          ) {
            if (rm.clientEndpoint == "sms") {
              rsms = rsms + 1;
            } else {
              r = r + 1;
            }
          }
        }
      });
      return { chat: r, sms: rsms };
    }
  },

  created() {
    let that = this;
    setTimeout(function() {
      that.noteBlock = false;
    }, 15000);

    window.addEventListener("beforeunload", () => this.AdminPresenceOff());
  },

  mounted() {
    this.activeMenu = this.$route.name;
    this.watchAdminsOnline();
    this.addMessages();
    this.loadRooms();
    this.watchRooms();

    //Notifications Tab
    this.loadNotifications();
    this.watchNotifications();

    //FollowUpSection
    this.loadActiveFollowUps();
  },

  methods: {
    addMessages() {
      let that = this;
      firebase
        .database()
        .ref("messages")
        .orderByChild("route/division")
        .equalTo(`${this.currAdmin.division}`)
        .on("child_added", function(snapshot) {
          var msg = snapshot.val();
          msg["msgkey"] = snapshot.key;
          msg.sendDate = new Date(msg.sendDate);
          that.SetMessages(msg);
          that.SortConvos();
        });
    },

    watchRooms() {
      let that = this;
      firebase
        .database()
        .ref("chatrooms")
        .orderByChild("division")
        .equalTo(`${this.currAdmin.division}`)
        .on("child_changed", function(snapshot) {
          let d = snapshot.val();
          if (that.valid(d.ssId)) {
            let ind = that.rooms.findIndex(el => el.ssId == d.ssId);
            if (ind >= 0) {
              if (that.rooms[ind].adminId != d.adminId) {
                that.windowNoteNewRoom(d);
              }
              that.$set(that.rooms, ind, d);
              that.CheckRoomAssigned(d);
            }
          }
        });

      firebase
        .database()
        .ref("chatrooms")
        .orderByChild("division")
        .equalTo(`${this.currAdmin.division}`)
        .on("child_removed", function(snapshot) {
          let d = snapshot.val();
          if (that.valid(d.ssId)) {
            let ind = that.rooms.findIndex(el => el.ssId == d.ssId);
            if (ind >= 0) {
              that.rooms.splice(ind, 1);
            }
          }
        });
    },

    loadRooms() {
      let that = this;
      firebase
        .database()
        .ref("chatrooms")
        .orderByChild("division")
        .equalTo(`${this.currAdmin.division}`)
        .on("child_added", async function(snapshot) {
          let currentRoomId = snapshot.val().ssId;
          if (currentRoomId == undefined || currentRoomId == "") {
            return;
          }

          that.rooms.push(snapshot.val());
          that.CheckRoomAssigned(snapshot.val());

          that.windowNoteNewRoom(snapshot.val());

          that.rooms.sort((a, b) =>
            Date.parse(a.dateRoomCreate) > Date.parse(b.dateRoomCreate) ? 1 : -1
          );

          that.loadRoomStatus(currentRoomId);
          that.SortConvos();

          // if (snapshot.val().clientEndpoint == "sms") {
          //   that.IsApptTodayFunc(snapshot.val());
          // }

          return;
        });

      this.watchRoomsStatus();
    },

    loadRoomStatus(ssid) {
      let that = this;
      firebase
        .database()
        .ref(`roomStatus/${ssid}`)
        .once("value")
        .then(snap => {
          if (snap.val() != undefined && snap.val() != null) {
            that.SetStatus(ssid, snap.val());
          }
        });
    },

    watchRoomsStatus() {
      let that = this;
      firebase
        .database()
        .ref(`roomStatus`)
        .on("child_changed", function(csnap) {
          that.SetStatus(csnap.key, csnap.val());
          that.readMsgCheck(csnap.key);

          that.StatusNotify(csnap.key, csnap.val());
        });
    },

    StatusNotify(ssId, data) {
      if (
        !this.noteBlock &&
        data.client_page == "online" &&
        this.currAdmin.showNotifications
      ) {
        let rm = this.rooms.find(el => el.ssId == ssId);
        let notebody = this.valid(rm)
          ? `${rm.user_firstName} ${rm.user_lastName} (${rm.userId})`
          : "New page landing";

        statusTrack.play();
        let statusNotif = new Notification(`Customer is online`, {
          requireInteraction: true,
          body: notebody
        });
        statusNotif.onclick = function() {
          window.focus();
          this.notifOnclick("Chat");
        };
      }
    },

    watchAdminsOnline() {
      firebase
        .database()
        .ref("adminsOnline")
        .orderByChild("division")
        .equalTo(this.currAdmin.division)
        .on("child_added", snap => {
          let adminData = snap.val();
          if (
            this.currAdmin.id != adminData.adminId &&
            !this.adminsOnline.find(el => el.adminId === adminData.adminId)
          ) {
            this.adminsOnline.push(adminData);
          }
        });

      firebase
        .database()
        .ref("adminsOnline")
        .orderByChild("division")
        .equalTo(this.currAdmin.division)
        .on("child_removed", snap => {
          let adminRem = snap.val();
          if (this.currAdmin.id != adminRem.adminId) {
            for (let qj = 0; qj < this.adminsOnline.length; qj++) {
              if (this.adminsOnline[qj].adminId == adminRem.adminId) {
                this.adminsOnline.splice(qj, 1);
                break;
              }
            }
          } else {
            this.$emit("glogout", true);
          }
        });

      firebase
        .database()
        .ref("adminsOnline")
        .orderByChild("division")
        .equalTo(this.currAdmin.division)
        .on("child_changed", snapCh => {
          let adminData = snapCh.val();
          if (this.currAdmin.id != adminData.adminId) {
            let ind = this.adminsOnline.findIndex(
              el => el.adminId === adminData.adminId
            );
            if (ind > -1) {
              this.$set(this.adminsOnline, ind, adminData);
            }
          } else {
            this.$emit("adminupd", adminData);
          }
        });
    },

    CheckRoomAssigned(rm) {
      //Setting time for warning if assigned to human

      if (
        rm.adminId == this.currAdmin.id &&
        (!this.valid(rm.assign_expire) ||
          Date.parse(new Date()) > rm.assign_expire)
      ) {
        firebase
          .database()
          .ref(`chatrooms/${rm.ssId}`)
          .update({
            assign_expire: new Date().setMinutes(new Date().getMinutes() + 30)
          });
      }
    },

    IsApptTodayFunc(rm) {
      if (this.valid(rm.userId) || this.valid(rm.userphone)) {
        let todaysDate = new Date().toLocaleDateString("en-US", {
          timeZone: "America/Edmonton"
        });
        let that = this;

        let [searchkey, searchval] = [
          this.valid(rm.userId) ? "userId" : "cell",
          this.valid(rm.userId) ? rm.userId : rm.userphone.substring(2)
        ];

        firebase
          .firestore()
          .collection(`events`)
          .where(searchkey, "==", searchval)
          .where("xdate", ">=", Date.parse(`${todaysDate} 12:00:02 AM MDT`))
          .where("xdate", "<=", Date.parse(`${todaysDate} 11:55:58 PM MDT`))
          .get()
          .then(clappts => {
            clappts.forEach(clapptData => {
              if (
                clapptData.data().type == "appointment" &&
                clapptData.data().status == "scheduled"
              ) {
                let indx = that.rooms.findIndex(el => el.ssId == rm.ssId);
                if (indx >= 0) {
                  that.rooms[indx]["hasTodaysAppt"] = true;
                  that.$set(that.rooms, indx, that.rooms[indx]);
                }
              }
            });
          });
      }
    },

    SetMessages(msg) {
      if (this.messages[msg.ssId] == undefined) {
        this.$set(this.messages, msg.ssId, []);
      }

      this.messages[msg.ssId].push(msg);
      this.$set(this.messages, msg.ssId, this.messages[msg.ssId]);

      this.windowNoteNewMessage(msg);

      this.readMsgCheck(msg.ssId);
    },

    SetStatus(ssId, data) {
      this.$set(this.roomStats, ssId, data);
    },

    readMsgCheck(ssId) {
      if (
        this.roomStats[ssId] &&
        this.valid(this.roomStats[ssId].adminsWatching) &&
        Object.keys(this.roomStats[ssId].adminsWatching).length > 0
      ) {
        for (let key in this.messages[ssId]) {
          let ms = this.messages[ssId][key];

          if (ms.readMsg === false) {
            this.$set(this.messages[ssId][key], "readMsg", true);

            if (this.selectedRoomId == ssId) {
              this.MarkMsgRead(ms.msgkey);
            }
          }
        }
      }
    },

    MarkMsgRead(msgkey) {
      firebase
        .database()
        .ref(`messages/${msgkey}`)
        .update({ readMsg: true });
    },

    SetLastCheckTime(ssId) {
      let ind = this.rooms.findIndex(el => el.ssId == ssId);
      if (ind > -1) {
        this.$set(this.rooms[ind], "lastCheck", Date.parse(new Date()));
      }
    },

    SortConvos() {
      // let j = 0;
      for (let [k, el] of Object.entries(this.rooms)) {
        // j = j + 1;
        if (el.lastCheck == undefined) {
          this.$set(this.rooms[k], "lastCheck", Date.now());
        }
        if (el.priortime == undefined) {
          el["priortime"] = Date.parse(new Date(el.dateRoomCreate));
        }
        if (this.messages[el.ssId] && this.messages[el.ssId].length > 0) {
          if (
            (el.priority == undefined || el.priority != 1) &&
            this.messages[el.ssId].find(
              elem => elem.route.from == "client" && elem.readMsg === false
            )
          ) {
            this.$set(this.rooms[k], "priority", 1);
            this.$set(
              this.rooms[k],
              "priortime",
              Date.now() + Math.floor(Math.random() * 92)
            );
          } else if (
            (el.priority == 1 &&
              Date.now() - el.priortime > 300000 &&
              Date.now() - el.lastCheck > 240000) ||
            el.priority != 1
          ) {
            if (
              el.priority == 1 &&
              this.messages[el.ssId].find(
                elem => elem.route.from == "client" && elem.readMsg === false
              )
            ) {
              this.$set(this.rooms[k], "priortime", Date.now());
            } else {
              this.$set(this.rooms[k], "priority", 2);
            }
          }
        } else {
          this.$set(this.rooms[k], "priority", 2);
        }
      }
      let temp = [
        ...this.rooms
          .filter(el => el.priority == 1)
          .sort((a, b) => (a.priortime < b.priortime ? 1 : -1)),
        ...this.rooms
          .filter(el => el.priority == 2)
          .sort((a, b) => (a.priortime < b.priortime ? 1 : -1))
      ];
      this.rooms = temp;
    },

    ///NOTIFICATIONS TAB SECTION

    loadNotifications() {
      let that = this;
      firebase
        .database()
        .ref(`notifications/${this.currAdmin.division}`)
        .on("child_added", noteSnap => {
          if (that.valid(noteSnap.val().ssId)) {
            that.SetNotif(noteSnap.val());
          }
        });
    },

    watchNotifications() {
      let that = this;
      firebase
        .database()
        .ref(`notifications/${this.currAdmin.division}`)
        .on("child_changed", noteChangeSnap => {
          if (that.valid(noteChangeSnap.val().ssId)) {
            that.SetNotif(noteChangeSnap.val());
          }
        });
    },

    showBrowserNoteNotification(show, data) {
      if (
        !this.noteBlock &&
        show &&
        !(
          data.processed_status == "in_process" &&
          data.adminId != this.currAdmin.id
        ) &&
        this.currAdmin.showNotifications
      ) {
        let notif = new Object();
        if (this.notifications.filter(el => el.ssId == data.ssId).length == 1) {
          notif = new Notification("New notification", {
            requireInteraction: true,
            body: `From: ${data.customerId || "UnIdentified Client"} ${
              data.customerName
            }\nType: ${data.note_type} ${
              data.note_type == "appointment" ? data.appointment.action : ""
            }
                    `
          });
        } else {
          notif = new Notification("Notification Update", {
            requireInteraction: true,
            body: `From: ${data.customerName} (${data.customerId ||
              "UnIdentified Client"} )\nType: ${data.note_type} ${
              data.note_type == "appointment" ? data.appointment.action : ""
            }
                    `
          });
        }

        track.play();

        notif.onclick = function() {
          window.focus();
          this.notifOnclick("Notifications");
        };
      }
    },

    SetNotif(data) {
      this.$set(this.allNotifs, data.ssId, data);

      if (data.processed_status == "processed") {
        delete this.allNotifs[data.ssId];

        this.$set(
          [],
          this.notifications,
          this.notifications.filter(el => el.ssId != data.ssId)
        );

        if (data.adminId == this.currAdmin.id) {
          this.RemoveNotif(data);
        }
      } else {
        data.groupDocs
          .filter(
            el =>
              !this.notifications.find(
                elem => elem.ssId == data.ssId && elem.docID == el
              )
          )
          .forEach((note, index) => {
            this.loadNoteFromFt(note, index == 0);
          });
      }
    },

    RemoveNotif(data) {
      for (let i in data.groupDocs) {
        firebase
          .firestore()
          .collection("Notifications")
          .doc(data.groupDocs[i])
          .set(
            {
              processed_status: "processed",
              processed_by: this.currAdmin.id,
              status: "inactive",
              processed_time: new Date()
            },
            { merge: true }
          );
      }

      if (this.valid(data.mode) && data.mode == "markEvent") {
        firebase
          .firestore()
          .collection(`events`)
          .where("handled_by", "==", "bot")
          .where(`userId`, "==", data.clientId)
          .get()
          .then(rss => {
            rss.forEach(rs => {
              if (rs.data().type == "appointment") {
                firebase
                  .firestore()
                  .doc(`events/${rs.id}`)
                  .set(
                    {
                      isProcessed: true,
                      location: this.currAdmin.location
                    },
                    { merge: true }
                  );
              }
            });
          });
      }

      firebase
        .database()
        .ref(`notifications/${this.currAdmin.division}/${data.ssId}`)
        .remove();
    },

    loadNoteFromFt(docId, showNote) {
      let that = this;
      firebase
        .firestore()
        .doc(`Notifications/${docId}`)
        .get()
        .then(function(docSnap) {
          if (docSnap.exists) {
            let rs = docSnap.data();
            rs["docID"] = docId;
            that.notifications.push(rs);
            that.showBrowserNoteNotification(showNote, rs);
            // that.addNotifData(rs);
          }
        });
    },

    /// Followup section

    loadActiveFollowUps() {
      firebase
        .database()
        .ref(`followup/${this.currAdmin.location}`)
        .on("child_added", snap => {
          let d = snap.val();
          this.activeFollowUps.push(d);
          this.activeFollowUps.sort((a, b) =>
            a.scheduled_time > b.scheduled_time ? 1 : -1
          );
          // Date.parse(a.scheduled_time) > Date.parse(b.scheduled_time) ? 1 : -1
        });

      firebase
        .database()
        .ref(`followup/${this.currAdmin.location}`)
        .on("child_changed", snap => {
          let ind = this.activeFollowUps.findIndex(el => el.ssId == snap.key);
          if (ind >= 0) {
            this.$set(this.activeFollowUps, ind, snap.val());
          }
        });

      firebase
        .database()
        .ref(`followup/${this.currAdmin.location}`)
        .on("child_removed", snap => {
          let ind = this.activeFollowUps.findIndex(el => el.ssId == snap.key);
          if (ind >= 0) {
            this.activeFollowUps.splice(ind, 1);
          }
        });
    },

    /// CurrAdmin

    AdminPresenceOff() {
      if (this.valid(this.currAdmin.id)) {
        let hotrooms = [];

        let hrooms = this.rooms.filter(el => el.adminId == this.currAdmin.id);
        for (let i in hrooms) {
          hotrooms.push(hrooms[i].ssId);
        }

        firebase
          .database()
          .ref(`adminsOnline/${this.currAdmin.id}`)
          .update({
            presenceStatus: "off",
            hotRooms: hotrooms
          });
      }
    },

    logOut() {
      let notesInProcess = false;
      for (let ky in this.allNotifs) {
        let elem = this.allNotifs[ky];
        if (
          elem.processed_status == "in_process" &&
          elem.adminId == this.currAdmin.id
        ) {
          notesInProcess = true;
          break;
        }
      }

      if (notesInProcess) {
        alert(
          "You have Notifications marked as 'In Process'. Please, finish the process before leaving"
        );
      } else if (
        this.rooms.filter(el => el.adminId == this.currAdmin.id).length > 0
      ) {
        alert(
          "You have conversations in progress. Finish chatting first, please"
        );
      } else {
        if (this.currAdmin && this.currAdmin.id) {
          this.turnAllDbListenersOff();
          firebase
            .firestore()
            .doc(
              `admins/${this.currAdmin.location}/adminsInfo/${this.currAdmin.id}`
            )
            .set({ status: "offline", loggedIn: false }, { merge: true });

          firebase
            .database()
            .ref(`adminsOnline/${this.currAdmin.id}`)
            .remove();

          this.$emit("glogout", true);
        }
      }
    },

    ///CurrAdmin Settings

    ApplyMySetChanges() {
      this.profileAdmin.userOptionalName = `${this.profileAdmin.firstName} ${this.profileAdmin.lastName}`;
      this.profileAdmin.notificationsToEmail = this.profileAdmin.noteToEmail
        ? this.profileAdmin.notificationsToEmail
        : "";
      delete this.profileAdmin["firstName"];
      delete this.profileAdmin["lastName"];
      delete this.profileAdmin["noteToEmail"];

      firebase
        .firestore()
        .doc(
          `admins/${this.currAdmin.location}/adminsInfo/${this.currAdmin.id}`
        )
        .set(this.profileAdmin, { merge: true });

      firebase
        .database()
        .ref(`adminsOnline/${this.currAdmin.id}`)
        .update({
          routeChats: this.profileAdmin.chatRoute,
          emailToNotes: this.profileAdmin.notificationsToEmail,
          notificationsAllowed: this.profileAdmin.showNotifications,
          popupAllowed: this.profileAdmin.popupAllowed,
          transcriptToEmail: this.profileAdmin.transcriptToEmail,
          name: this.profileAdmin.userOptionalName
        });
    },
    SetMySets() {
      this.profileAdmin = Object.assign({}, this.profileAdmin, this.currAdmin);
      let name =
        this.currAdmin.userOptionalName || this.currAdmin.user_google_name;
      this.$set(this.profileAdmin, "firstName", name.split(" ")[0]);
      this.$set(this.profileAdmin, "lastName", name.split(" ")[1]);
      this.$set(
        this.profileAdmin,
        "noteToEmail",
        this.currAdmin.notificationsToEmail ? true : false
      );
      if (!this.profileAdmin.noteToEmail) {
        this.profileAdmin.notificationsToEmail = this.currAdmin.email;
      }
    },

    ///WINDOW NOTIFICATION BLOCK

    windowNoteNewRoom(newRoom) {
      let blockIndex = this.blockNoteList.findIndex(el => el == newRoom.ssId);

      let newSMSroom =
        newRoom.clientEndpoint == "sms" &&
        !this.valid(newRoom.adminParticipants.find(el => el != ""));

      if (
        !this.noteBlock &&
        blockIndex < 0 &&
        (newRoom.adminId == this.currAdmin.id || newSMSroom)
      ) {
        if (
          newRoom.adminId == this.currAdmin.id &&
          this.currAdmin.popupAllowed == true
        ) {
          window.name = "adminChat";
          this.PopUpWindow();
        }

        let notif = new Notification(
          `New ${
            newRoom.clientEndpoint == "sms" ? "SMS" : "live"
          } chat established`,
          {
            //нотиф когда новая комната появляется
            requireInteraction: true,
            body: `Customer: ${
              !newRoom.userId
                ? "Unidentified Customer"
                : newRoom.user_firstName +
                  " " +
                  newRoom.user_lastName +
                  " (" +
                  newRoom.userId +
                  ")"
            }`
          }
        );
        track.play();
        let that = this;
        notif.onclick = function() {
          window.focus();
          that.notifOnclick("Chat");
        };
      }
      if (blockIndex >= 0) {
        this.blockNoteList.splice(blockIndex, 1);
      }
    },

    windowNoteNewMessage(msg) {
      let rm = this.rooms.find(
        el => el.ssId == msg.ssId && el.adminId == this.currAdmin.id
      );

      if (
        !this.noteBlock &&
        rm &&
        msg.route.from === "client" &&
        (document.hidden == true ||
          this.$route.name != "Chat" ||
          this.selectedRoomId != rm.ssId)
      ) {
        track2.play();
        let notif = new Notification("New message", {
          //нотиф когда приходит новое сообщение и окно открыто
          requireInteraction: true,
          body: `From: ${
            !rm.userId
              ? "Unidentified Customer"
              : rm.user_firstName +
                " " +
                rm.user_lastName +
                " (" +
                rm.userId +
                ")"
          }\nMessage: ${msg.data.text}`
        });
        notif.onclick = function() {
          window.focus();
          this.notifOnclick("Chat");
        };
      }
    },

    notifOnclick(routeName) {
      if (this.$route.name != routeName) {
        this.$route.push({ name: routeName });
        this.activeMenu = routeName;
      }
    },

    notifFunc() {
      if (!window.Notification) {
        console.log("Browser does not support notifications.");
      } else {
        // check if permission is already granted
        if (Notification.permission === "granted") {
          // show notification here
        } else {
          // request permission from user
          Notification.requestPermission()
            .then(function(p) {
              if (p === "granted") {
                // show notification here
              } else {
                console.log("User blocked notifications.");
              }
            })
            .catch(function(err) {
              console.error(err);
            });
        }
      }
    },

    PopUpWindow() {
      var w = window.open("", "adminChat");
      w;
      var myWindow = window.open(
        "",
        "",
        `width=${0.75 * window.screen.width}, height=${0.5 *
          window.screen.height}`
      ); // Opens a new window
      myWindow.document.write(this.NotifWindow());
      myWindow.focus();
    },

    turnAllDbListenersOff() {
      firebase
        .database()
        .ref("chatrooms")
        .orderByChild("division")
        .equalTo(`${this.currAdmin.division}`)
        .off();

      firebase
        .database()
        .ref("messages")
        .orderByChild("route/division")
        .equalTo(`${this.currAdmin.division}`)
        .off();

      firebase
        .database()
        .ref(`roomStatus`)
        .off();

      firebase
        .database()
        .ref("adminsOnline")
        .orderByChild("division")
        .equalTo(this.currAdmin.division)
        .off();

      firebase
        .database()
        .ref(`notifications/${this.currAdmin.division}`)
        .off();

      firebase
        .database()
        .ref(`followup/${this.currAdmin.location}`)
        .off();
    },

    valid(vl) {
      return vl != undefined && vl != null && vl != "";
    },

    NotifWindow() {
      let s = `<html><body><div style="width: 100%; margin-top:15%;">
          <div style="margin: auto; width: 60%;">
            <img src="https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/widget_pics%2Fclient_wink.png?alt=media&token=c176a8a2-580f-4c5b-8270-0a1a1e982139" style="margin: auto; float: left;width: 25%;
    padding-left: 10%;">
            <p style="float:right;font-weight:bold;font-size:28px; padding-top: 3%; max-width: 60%;   font-family: sans-serif;">You have a customer waiting for reply!</p>
          <p style="

    text-align: center;
">
    <button id="gotobutton" type="button" style="

    background: gold;
    border: 2px solid gold;
    width: 50%;
    height: 10%;
    color: darkblue;
    font-size: 20px;
    border-radius: 10px;
    cursor: pointer;
"> Go to Conversation </button> 
</p>
          </div>
        </div>
                <script type="text/javascript">
              document.addEventListener('DOMContentLoaded', (event) => {
         var el = document.getElementById("gotobutton");
            el.addEventListener("click", gotoFunc);
      });

              function gotoFunc(){
                window.open('javascript:void window.focus()', 'adminChat', '');
      window.close();

              };
window.document.dispatchEvent(new Event("DOMContentLoaded", {
  bubbles: true,
  cancelable: true
}));
            `;
      s = s + "<" + "/" + "script></body></html>";
      return s;
    }
  }
};
</script>
<style >
/*-------------------------
    The menu
--------------------------*/
.headerTop {
  height: 52px;
}

.routerLinkStyle a,
.routerLinkStyle a:visited {
  outline: none;
  color: #389dc1;
}

.routerLinkStyle a:hover {
  text-decoration: none;
  background-color: #ffd000;
}

/* a.logged {
  background-color: #000000;
} */

section,
footer,
header,
aside,
nav {
  display: block;
}

nav {
  background-color: #ffffff;
  box-shadow: 0 1px 1px #ccc;
  border-radius: 2px;
}

nav .routerLinkStyle a {
  display: inline-block;
  padding: 18px 30px;
  color: rgb(3, 0, 153) !important;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none !important;
  line-height: 1;
  text-transform: uppercase;
  background-color: transparent;

  -webkit-transition: background-color 0.25s;
  -moz-transition: background-color 0.25s;
  transition: background-color 0.25s;
}

nav .routerLinkStyle a:first-child {
  border-radius: 2px 0 0 2px;
}

nav .routerLinkStyle a:last-child {
  border-radius: 0 2px 2px 0;
}

nav.Chat .Chat,
nav.Notifications .Notifications,
nav.TimeControl .TimeControl,
nav.contact .contact,
nav.Settings .Settings,
nav.FollowUpPanel .FollowUpPanel,
nav.ReminderPanel .ReminderPanel {
  background-color: #ffd000;
}

.logoutAvatarClass {
  display: inline;
}
#dropdownProfile button {
  border-radius: 50%;
}
.profBtn {
  border-radius: 0.25rem !important;
}
#dropdownProfile p {
  margin-bottom: 0;
  line-height: 22px;
}
#dropdownProfile li {
  text-align: center;
}

.lineH50 {
  line-height: 50px;
  /* text-align: end; */
}
#main {
  margin-bottom: 10px;
}

#settingsList .modal-body {
  padding: 0px;

  background: #ffffff;
  box-shadow: 2px 2px 5px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.userNameStyle {
  color: #202124;
  font-size: 16px;
}
.userEmailStyle {
  color: #5f6368;
  font-size: 14px;
}
.ht100 {
  height: 100%;
}

.logosize {
  max-width: 145%;
}

@media (max-width: 992px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 100%;
  }

  nav .rsize a {
    padding: 18px 12px;
    font-size: 13px;
  }
  .logosize {
    max-height: 85%;
    max-width: 145%;
  }
}

@media (min-width: 993px) and (max-width: 1240px) {
  .logosize {
    max-width: 145%;
  }
  nav .rsize a {
    padding: 18px 15px;
    font-size: 14px;
  }
}
</style>